import { gql } from '@apollo/client';

export const GET_VOLUMES = gql`
  query getVolumes($today: String, $yesterday: String, $firstDayOfMonth: String) {
    categoryDailyVolumes: logVolumesByCategory(start: $yesterday, end: $today) {
      categoryId
      volumeBytes
    }
    otherDailyVolumes: logVolumes(start: $yesterday, end: $today) {
      filter
      volumeBytes
    }
    categoryMonthlyVolumes: logVolumesByCategory(start: $firstDayOfMonth, end: $today) {
      categoryId
      volumeBytes
    }
    otherMonthlyVolumes: logVolumes(start: $firstDayOfMonth, end: $today) {
      filter
      volumeBytes
    }
  }
`;

export const GET_BILLING_AND_USAGE_DATA = gql`
  query getVolumesAndBudgetCategories {
    budgetCategories {
      id
      accountId
      lastOverageEmailAt
      logFilter
      name
      plannedCostPerMonth
      plannedGbPerDay
      position
      filters {
        id
        categoryId
        disabledUntil
        value
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
    account: accountData {
      isCustomPlan
      email
      billingType
      planData {
        gbPerDay
        price
        retention
      }
      planDataForNextBillingCycle {
        gbPerDay
        price
        retention
      }
      canChangeBillingPlan
      hasCreditCard
      isLogOverageNotificationsWidgetEnabled
      isMasterWithSubsidiaries
    }
  }
`;

export const BILLING_NOTIFICATIONS = gql`
  query billingNotifications {
    billingNotifications {
      budgetNotification {
        id
        accountId
        disabled
        emails
      }
      overageNotificationSettings {
        dailyThresholdGib
        dailyThresholdPercent
        disabled
        emails
      }
    }
  }
`;

export const ADD_BUDGET_CATEGORY = gql`
  mutation addCategory($budgetCategory: BudgetCategoryRequestInput!) {
    createBudgetCategory(budgetCategoryRequest: $budgetCategory) {
      id
    }
  }
`;

export const UPDATE_BUDGET_CATEGORY = gql`
  mutation updateBudgetCategory($id: ID!, $budgetCategory: BudgetCategoryRequestInput!) {
    updateBudgetCategory(id: $id, budgetCategoryRequest: $budgetCategory) {
      id
    }
  }
`;

export const DELETE_BUDGET_CATEGORY = gql`
  mutation deleteBudgetCategory($id: ID!) {
    deleteBudgetCategory(id: $id) {
      id
    }
  }
`;

export const MOVE_BUDGET_CATEGORY = gql`
  mutation moveBudgetCategory($id: ID!, $position: Int!) {
    moveBudgetCategory(id: $id, position: $position) {
      position
    }
  }
`;

export const ADD_FILTER = gql`
  mutation addFilter($categoryId: ID!, $filterRequest: BudgetCategoryDiscardFilterRequestInput!) {
    createFilter(categoryId: $categoryId, filterRequest: $filterRequest) {
      id
    }
  }
`;

export const UPDATE_FILTER = gql`
  mutation updateFilter($categoryId: Int!, $filterId: ID!, $filterRequest: BudgetCategoryDiscardFilterRequestInput!) {
    updateFilter(categoryId: $categoryId, filterId: $filterId, filterRequest: $filterRequest) {
      id
      value
      disabledUntil
    }
  }
`;

export const DELETE_FILTER = gql`
  mutation deleteFilter($categoryId: Int!, $filterId: ID!) {
    deleteFilter(categoryId: $categoryId, filterId: $filterId) {
      id
    }
  }
`;

export const UPDATE_OVERAGE_NOTIFICATIONS = gql`
  mutation updateOverageNotificationSettings(
    $overageNotificationSettingsRequest: OverageNotificationSettingsRequestInput
  ) {
    updateOverageNotificationSettings(overageNotificationSettingsRequest: $overageNotificationSettingsRequest) {
      dailyThresholdGib
      dailyThresholdPercent
      disabled
      emails
    }
  }
`;

export const UPDATE_BUDGET_NOTIFICATIONS = gql`
  mutation updateBudgetNotification($budgetNotificationRequest: BudgetNotificationRequestInput) {
    updateBudgetNotification(budgetNotificationRequest: $budgetNotificationRequest) {
      id
      disabled
      emails
    }
  }
`;

export const SET_PLAN = gql`
  mutation setAccountFlexPlan($dailyGb: Int!, $retentionDays: Int!) {
    setAccountFlexPlan(dailyGb: $dailyGb, retentionDays: $retentionDays)
  }
`;

export const REQUEST_EMAIL_CONFIRMATION = gql`
  mutation requestEmailConfirmation {
    requestEmailConfirmation
  }
`;

export const UPDATE_CREDIT_CARD = gql`
  mutation updateCreditCard($billingInformation: BillingInformationInput!, $stripeToken: String!) {
    updateCreditCard(billingInformation: $billingInformation, stripeToken: $stripeToken)
  }
`;

export const GET_HINDSIGHT_DATA = gql`
  query getHindsightData($startDate: String!, $endDate: String!) {
    hindsightData(startDate: $startDate, endDate: $endDate) {
      retentionDays
      storageAverageVolume
      storageTotalCost
      searchCount
      searchTotalCost
      searchTotalVolume
      searchDetailsQuery
      searchCostsPowerQuery
      storageCostsPowerQuery
    }
  }
`;

export const HINDSIGHT_RETENTION_QUERY = gql`
  query getHindsightData($startDate: String!, $endDate: String!) {
    hindsightData(startDate: $startDate, endDate: $endDate) {
      retentionDays
    }
  }
`;
